const CampaignType = {
  Discount: "discount",
  Voucher: "voucher",
};

export default CampaignType;
